import * as z from "zod";

export const upsertSkioIntegration = {
  name: "upsertSkioIntegration" as const,
  input: z.object({ apiKey: z.string() }),
  output: z.object({ success: z.boolean() }),
};
